import React, { useState, useEffect } from "react";
import { fromJS } from "immutable";
import { connect } from "react-redux";
import { Form, Field, reduxForm, destroy } from "redux-form";
import { ToastContainer, toast } from "react-toastify";
import UserSideMenu from "../../menu/UserSideMenu";
import Header from "../common/HeaderAfterLogin";

import "react-toastify/dist/ReactToastify.css";
import {
  InputContact,
  DropDownContact,
  DropDownContactDistrict,
} from "../common/input";
import { getState } from "../../action/user_action";
import Footer from "../common/Footer";
import { scrollHandler, goToByScroll } from "../../util/animation";
// import Header from '../common/Header';
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";
import { history } from "../../history/history";
import {
  phoneNumber,
  email,
  string,
  maxLengthCheck,
} from "../../util/validate";
import AOS from "aos";

const DSAContactDash = (props) => {
  //Define the initial state.
  const [stateList, handleCityState] = useState([]);
  const [message, handleMessage] = useState("");
  const [districtList, handleDistrict] = useState([]);
  const [cityList, handleCity] = useState([]);

  //Initialize the scroll function
  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    props.getState();
    AOS.init({
      duration: 600,
    });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  /**
   * Submit the contact form that
   * containing the info object about the contact.
   */
  const handleSubmit = async (values) => {
    var mobileError = values.mobile ? phoneNumber(values.mobile) : undefined;
    var emailError = values.email ? email(values.email) : undefined;
    //  var nameError = values.name ? string(values.name): undefined
    //  var cityError = values.city ? string(values.city):undefined
    var nameLengthError = values.name
      ? maxLengthCheck(30, values.name)
      : undefined;
    var cityLengthError = values.city
      ? maxLengthCheck(30, values.city)
      : undefined;
    var emailLengthError = values.email
      ? maxLengthCheck(30, values.city)
      : undefined;
    //var companyLengthError = values.company ? maxLengthCheck(60, values.city) : undefined

    if (nameLengthError && !toast.isActive("1")) {
      toast.error("name " + nameLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    // else if (companyLengthError && !toast.isActive("1")) {
    //   toast.error("company " + nameLengthError, {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: false,
    //     hideProgressBar: true,
    //     toastId: "1"
    //   });
    //   return; }
    else if (emailLengthError && !emailError && !toast.isActive("1")) {
      toast.error("email " + emailLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (cityLengthError && !toast.isActive("1")) {
      toast.error("city " + cityLengthError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (mobileError && !toast.isActive("1")) {
      toast.error(mobileError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (emailError && !toast.isActive("1")) {
      toast.error(emailError, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (Object.keys(values).length != 5 && !toast.isActive("1")) {
      toast.error("All Fields are mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (
      Object.keys(values).length != 5 ||
      mobileError ||
      emailError ||
      nameLengthError ||
      cityLengthError ||
      emailLengthError
    ) {
      return;
    }
    let params = {
      ...values,
      message,
      status: "Open",
    };
    try {
      const data = await Axios.post(endPoints.becomedsa, params);
      const result = data.data.data.data;
      if (result) {
        props.destroyForm("contact");
        handleMessage("");
        toast.error(
          "Thanks! For Shown Your Interest to Become Trade Partner,We will respond soon",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: false,
            hideProgressBar: true,
            toastId: "1",
          }
        );
        setTimeout(() => {
          history.push("");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };


  //   render() {
  //     let { kycDetails } = this.state;
  return (
    <div className="main_wrapper">
      <UserSideMenu {...props} />
      <div className="dashboard_right_wrapper create_camp_container">
        <div className="right_wrapper_inner">
          <Header />
          <div className="dash_content_wrapper">
            <div className="content_wrapper_inner detail_content">
              <div className="create_kyc_wrapper">
                <h2 className="detail_kyc_header">BECOME TRADE PARTNER</h2>
                <div className="kycdetails_wrapper">
                  <h2 className="kycheader"></h2>
                  <div className="form_wrapper">
                    <p className="form_header">
                    Fill the form below to become Trade Partner (DIRECT SALES AGENT)  Of BIGFM
                    </p>
                    <div className="contact_form">
                      {/* <form className="contact_form"> */}
                      <Form
                        className="contact_form"
                        // onSubmit={props.handleSubmit(handleSubmit)}
                      >
                        <div className="form_left_wrapper">
                          <div className="form_left">
                            <div className="contact_field">
                              <div className="contact_label">
                                <label>Name</label>
                              </div>
                              <div className="contact_input">
                                {/* <input type="text" placeholder="Enter your name"/> */}
                                <Field
                                  type="text"
                                  name="name"
                                  placeholder="Enter your name"
                                  component={InputContact}
                                />
                              </div>
                            </div>
                            <div className="contact_field">
                              <div className="contact_label">
                                <label>Email ID</label>
                              </div>
                              <div className="contact_input">
                                {/* <input type="email" placeholder="Enter valid email id"/> */}
                                <Field
                                  type="text"
                                  name="email"
                                  placeholder="Enter valid email id"
                                  component={InputContact}
                                />
                              </div>
                            </div>
                            <div className="contact_field">
                              <div className="contact_label">
                                <label>Mobile</label>
                              </div>
                              <div className="contact_input">
                                {/* <input type="text" placeholder="Enter your mobile number" /> */}
                                <Field
                                  type="text"
                                  name="mobile"
                                  placeholder="Enter your mobile number"
                                  component={InputContact}
                                />
                              </div>
                            </div>

                         </div>
                          <div className="contact_submit">
                            <button>SUBMIT</button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  //   };
};

export default DSAContactDash

// export default connect(mapStateToProps, mapDispatchToProps)(KycDetailComp);



// WEBPACK FOOTER //
// ./web/components/becomedsa/contactDashboard.js